<template>
  <div class="webview flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col xs="12">
          <div class="clearfix">
            <h1 class="web-hidden">1on1navi: Help</h1>
            <div role="tablist">
              <b-card
                v-for="(help, idx) in helps"
                v-bind:key="'help'+idx"
              no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle="'help' + idx" variant="info">{{ help.head }}</b-btn>
                </b-card-header>
                <b-collapse :id="'help' + idx" accordion="helpAccordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text" v-html="help.body"></p>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
.webview {
  overflow: auto;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
}
h2 {
  font-size: 1.25rem;
}
h3 {
  font-size: 1.15rem;
}
h2 > span {
  margin-left: 1em;
  text-decoration: underline;
}
span.nth {
  margin-right: 0.5em;
}
ul.list-adjusted {
  padding-left: 1.5em;
}
.card-header .btn {
  white-space: normal;
  text-align: left;
}
</style>

<script>
export default {
  name: 'WebViewHelpsEN',
  data () {
    return {
      'helps': [
        {
          head: 'Basic menu of 1on1navi',
          body: `The following icons located on the left side of the top screen.
          <ul class="list-adjusted">
          <li>・${this.$t('topTitle')}</li>
          <li>・${this.$t('oneOnTitleType')}</li>
          <li>・${this.$t('rtfbType')}</li>
          <li>・${this.$t('sidebar.notice.title')}</li>
          <li>・${this.$t('sidebar.other.title')}</li>
          </ul>`
        },
        {
          head: 'Search for a user',
          body: `Tap “${this.$t('sidebar.people.title')}" submenu from “${this.$t('sidebar.other.title')}" at the bottom of the screen to display the search field and a list of recently checked users.<br><br>
                 Enter the username in the search field and the search results will be displayed. Information (profile, ${this.$t('topTitle')}, ${this.$t('oneOnTitleType')}, ${this.$t('rtfbType')}) will be displayed by tapping the corresponding username.`
        },
        {
          head: `${this.$t('popTitleStr3Type')}`,
          body: `By creating a group, it becomes possible to set the publishing range of ${this.$t('topTitle')}, ${this.$t('oneOnTitleType')}, and ${this.$t('rtfbType')} to the users registered in the group, and to perform settings to receive notifications of group members collectively.<br><br>
          Tap "${this.$t('sidebar.people.title')}" submenu from "${this.$t('sidebar.other.title')}" at the bottom of the screen to display the search field.<br>
          Tap "+" in the upper right of the Groups tab, enter a group name, and tap "Create".<br><br>
          Select "+" to the right of the member on the group creation screen, search for users, and select them when the users to be added are displayed (check box will be checked.)<br>
          Tap "<"in the upper left to add to the group member candidates. After repeating the user search and selection to select a group member, tap "Done" button in the upper right to create a group and add it to the group list. `
        },
        {
          head: `Register ${this.$t('tutorial[1].head')}（Register ${this.$t('okrDetailType')} and ${this.$t('keyResultDetailType')}）`,
          body: `Tap "${this.$t('topTitle')}" at the bottom of the screen to display the ${this.$t('sidebar.okr.list')}.<br><br>
          You can register ${this.$t('tutorial[1].head')} by tapping "+" in the upper right and by tapping "${this.$t('createDateString')}" or "${this.$t('popTitleStr5')}".<br><br>
          From the ${this.$t('okrDetailType')} registration screen, enter and select the following items.
          <ul class="list-adjusted">dueDateStr
            <li>・${this.$t('okrDetailType')}：Register the contents of ${this.$t('okrDetailType')} by character input or voice input.</li>
            <li>・${this.$t('dueDateStr')}：It is possible to set from the "${this.$t('dueDateStr')}" by tapping. Unless otherwise specified, it will be the date you input.</li>
            <li>・${this.$t('progressRateLabelTitle')}：Progress rate can be set by dragging a circular gauge. You can also change the value by tapping "+" and "-". </li>
            <li>・${this.$t('publicSettingLabelTitle')} : You can set by tapping "+" on the right. Unless otherwise specified, the disclosure range is ${this.$t('allPeopleStrType')}.</li>
            <li>・${this.$t('relatedOkrType')}：You can tap  "+" on the right to search and select a user to display the user's ${this.$t('sidebar.okr.list')}, tap ${this.$t('okrDetailType')} or ${this.$t('keyResultDetailType')}, and set it as ${this.$t('relatedOkrType')}.</li>
          </ul>
          Tap ${this.$t('saveStr')} in the upper right, and tap ${this.$t('saveStr')} or ${this.$t('popTitleStr2Type')} to complete registration or draft saving.<br>
          After registering ${this.$t('okrDetailType')}, you can continue to register ${this.$t('keyResultDetailType')}. The registered contents of ${this.$t('okrDetailType')} are the same as registered contents of ${this.$t('okrDetailType')}.<br><br>
          ${this.$t('keyResultDetailType')} can also be registered after completing the registration of ${this.$t('okrDetailType')}.<br>
          From the ${this.$t('sidebar.okr.list')}, select the ${this.$t('okrDetailType')}, and tap "${this.$t('addKeyResultStr')}" on the ${this.$t('keyResultDetailType')} tab in the ${this.$t('okrDetailType')} details to register the ${this.$t('okrDetailType')}.

          `
        },
        {
          head: `Confirm ${this.$t('topTitle')}`,
          body: `Tap "${this.$t('topTitle')}" at the bottom of the screen to display the ${this.$t('sidebar.okr.list')}.<br><br>
          For ${this.$t('okrDetailType')}, progress rate, content, ${this.$t('dueDateStr')}, number of comments, number of ${this.$t('relatedOkrType')} are displayed, and information of ${this.$t('keyResultDetailType')} linked to ${this.$t('okrDetailType')} is displayed below.<br><br>
          ※If the number of comments and ${this.$t('relatedOkrType')} numbers is orange and bold, there are unread comments and ${this.$t('relatedOkrType')}.<br><br>
          You can confirm the details by selecting ${this.$t('okrDetailType')} or ${this.$t('keyResultDetailType')} you want to confirm the details from the ${this.$t('sidebar.okr.list')}. The following items are displayed.
          <ul class="list-adjusted">
            <li>・Username</li>
            <li>・Start date </li>
            <li>・${this.$t('okrDetailType')} ※If there are a lot of characters, it will be highlighted, but you can check the contents by tapping the "${this.$t('moreBtnTitle')} ".</li>
            <li>・${this.$t('dueDateStr')}</li>
            <li>・${this.$t('releaseLabelTitle')}</li>
            <li>・Progress rate</li>
            <li>・${this.$t('addKeyResultStr')} ※Tab display only for ${this.$t('okrDetailType')}</li>
            <li>・${this.$t('commentTabTitle')}</li>
            <li>・${this.$t('relatedOkrType')} ※${this.$t('relatedOkrType')} also display ${this.$t('topTitle')} associated with other users.</li>
          </ul>`
        },
        {
          head: `Associate ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')}) as ${this.$t('relatedOkrType')}.`,
          body: `Tap "${this.$t('topTitle')}" at the bottom of the screen to display the ${this.$t('sidebar.okr.list')}.
          Tap ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}) to be related from the ${this.$t('sidebar.okr.list')}, and the details of ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}) will be displayed.<br>
          ※ You need to enter ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}) in advance.<br><br>
          Tap "${this.$t('relatedOkrType')}" in the middle of the ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}) detail screen, and tap "${this.$t('addOkrStr')}" at the bottom of the screen.<br><br>
          Search for the user who has set the ${this.$t('tutorial[1].head')} you want to associate in the search column (magnifying glass mark) at the top of the screen, and tap the right person within the user displayed in the search results, or " ${this.$t('checkUserStrType')}".<br><br>
          Tap the ${this.$t('tutorial[1].head')} you want to associate from the ${this.$t('sidebar.okr.list')} of the tapped user.

          “${this.$t('popTitleStrType')}: ${this.$t('popMessageStr20')} " window opens, tap "${this.$t('addStr')}" to associate.<br><br>
          （Confirmation method)<br>
          Associating with related OKR is displayed by tapping " ${this.$t('relatedOkrType')}" in the middle of the screen of related ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}).`

        },
        {
          head: `Change the progress rate of ${this.$t('tutorial[1].head')}`,
          body: `Tap "${this.$t('topTitle')}" at the bottom of the screen to display the ${this.$t('sidebar.okr.list')}.<br><br>
          Tap ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}) you want to change the progress rate from the ${this.$t('sidebar.okr.list')},  and display the details of ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')}).<br>
          ※ You need to enter ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}) in advance.<br><br>
          "Progress rate" can be changed by sliding 〇 in the "${this.$t('progressRateLabelTitle')}" circular gauge in the middle of the detail screen of the ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')} or tapping "-" and "+" on the left/right of the pie chart.`
        },
        {
          head: 'Complete OKR, Confirm Completed OKR',
          body: `Tap "${this.$t('topTitle')}" at the bottom of the screen to display the ${this.$t('sidebar.okr.list')}.<br><br>
          Tap Objective (/ Key Result) to be completed from the ${this.$t('sidebar.okr.list')} to display the details of ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')}).<br>
          ※ You need to enter ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}) in advance.<br><br>
          When tap "..." in the upper right of the screen, "${this.$t('okrEditType')}" "${this.$t('toComplete')}", "${this.$t('deleteStr')}", "${this.$t('cancelStr')}" will be displayed in the window. Tap "${this.$t('saveStr')}".<br><br>
          When "${this.$t('popTitleStrType')}: ${this.$t('popMessageStr16')} " window will open, tap "${this.$t('modalOkStr')}", secondly when "${this.$t('popTitleStr8')}: ${this.$t('popMessageStr17')}" window will open, tap "${this.$t('modalOkStr')}" to the status be completed.<br><br>
          （Confirm Closed OKR）<br>
          ＜${this.$t('okrDetailType')}＞<br>
          Tap "${this.$t('topTitle')}" at the bottom of the screen to display the ${this.$t('sidebar.okr.list')}.<br>
          Tap "三" at the top left of the screen.<br>
          As it will be the Menu screen, tap "${this.$t('completeOkrType')}” and the list of ${this.$t('completeOkrType')} is displayed.<br><br>

          ＜${this.$t('keyResultDetailType')}＞<br>
          Tap "${this.$t('topTitle')}" at the bottom of the screen to display the ${this.$t('sidebar.okr.list')}.<br>
          It is completed if there is a check mark in the upper right of ${this.$t('keyResultDetailType')} to want to confirm completion from the ${this.$t('sidebar.okr.list')}.`

        },
        {
          head: `Change the order of ${this.$t('okrDetailType')} displayed in the ${this.$t('sidebar.okr.list')}  `,
          body: `Tap "${this.$t('topTitle')}" at the bottom of the screen to display the ${this.$t('sidebar.okr.list')}.<br><br>
          Tap "三" on the upper left, and then tap "${this.$t('sortSettingString')}" to display the list and rearranging ${this.$t('okrDetailType')}.<br>
          Sorting can be done by tapping one of the following items.<br>
          <ul class="list-adjusted">
            <li>・${this.$t('registerDescending')}</li>
            <li>・${this.$t('registerAscending')}</li>
            <li>・${this.$t('updateDescending')}</li>
            <li>・${this.$t('updateAscending')}</li>
          </ul>`
        },
        {
          head: 'Register the reflection of on 1on1',

          body: `Tap "${this.$t('oneOnTitleType')}" at the bottom of the screen to display a list of implemented ${this.$t('tutorial[2].head')}.<br><br>
          Tap "+" in the upper right, and tap "${this.$t('createStr')} " or " ${this.$t('popTitleStr5')}" to register ${this.$t('tutorial[2].head')} reflection.<br><br>
          "${this.$t('dateLabelTitle')}" can be set by tapping "Date Input Dialog". Unless otherwise specified, it will be the date you input.<br><br>
          "${this.$t('publicSettingLabelTitle')}" can also be set by tapping the icon "+" on the right. Unless otherwise specified, the disclosure range is ${this.$t('allPeopleStrType')}.<br><br>
          The contents of reflection are registered in each field of the following items by character input.<br>
          <ul class="list-adjusted">
            <li>・${this.$t('firstContent1on1')}</li>
            <li>・${this.$t('secondContent1on1')}</li>
            <li>・${this.$t('thirdContent1on1')}</li>
            <li>・${this.$t('memoContent1on1')} ※It is private regardless of the above public settings.</li>
          </ul>
          <br>
          Tap "✓" on the upper right and tap "${this.$t('saveStr')}" or "${this.$t('popTitleStr2Type')}" to complete registration or draft saving.`
        },
        {
          head: 'Confirm 1on1’s reflection',
          body: `Tap "${this.$t('oneOnTitleType')}" at the bottom of the screen to display the list of implemented ${this.$t('tutorial[2].head')} in order from the latest.<br><br>
          From the ${this.$t('tutorial[2].head')} list, select ${this.$t('tutorial[2].head')} you want to check the details, and tap the next item to check the details.<br>
          <ul class="list-adjusted">
          <li>・${this.$t('firstContent1on1')}</li>
          <li>・${this.$t('secondContent1on1')}</li>
          <li>・${this.$t('thirdContent1on1')}</li>
          ※If there are a lot of characters, it will be highlighted, but you can check the contents by tapping "${this.$t('moreBtnTitle')}".  You can also check the contents of the following items, which are private, by tapping the icon "notebook" in the upper right.
          <li>・${this.$t('memoContent1on1')}</li>
          </ul>`
        },
        {
          head: `Send ${this.$t('oneOnOneRequest')}`,
          body: `Tap "${this.$t('oneOnTitleType')}" at the bottom of the screen to display a list of implemented ${this.$t('tutorial[2].head')}.<br>
          Tap "mail" on the upper left to display "${this.$t('oneOnOneRequest')}".<br><br>

          Set "To" by tapping "+" on the right.<br>
          In the "Comment" field, register the contents of 1on1 request by character input or voice input.<br>
          If you tap "${this.$t('senderTitle')}" below the comment field, 1on1 request will be sent to the destination.`
        },
        {
          head: `View ${this.$t('tutorial[3].head')}`,
          body: `Tap "${this.$t('rtfbType')}" icon at the bottom of the screen to display a list of ${this.$t('rtfbType')}.<br>
          If you tap the content you want to see, you will advance to the corresponding page (${this.$t('rtfbDetailType')}).<br>
          ※ If there are a lot of characters, it will be highlighted, but you can check the contents by tapping "${this.$t('moreBtnTitle')}".`
        },
        {
          head: `Post ${this.$t('tutorial[3].head')}`,
          body: `Tap "${this.$t('rtfbType')}" icon at the bottom of the screen to display a list of ${this.$t('rtfbType')}.<br><br>
          Tap "+" in the upper right, and tap "${this.$t('createStr')} " or " ${this.$t('popTitleStr5')}" to register ${this.$t('tutorial[3].head')}.<br>
          "${this.$t('publicSettingLabelTitle')}" can also be set by tapping the icon "+" on the right. Unless otherwise specified, the disclosure range is ${this.$t('allPeopleStrType')}.<br><br>
          Register the content of ${this.$t('tutorial[3].head')} by character input or voice input.You can paste an image on a comment by tapping the icon "clip".<br><br>
          Tap "✓" on the upper right and tap "${this.$t('saveStr')}" or "popTitleStr2Type" to complete registration or draft saving.`
        },
        {
          head: 'Post comments',
          body: `In the details of ${this.$t('tutorial[1].head')}, ${this.$t('tutorial[2].head')} and ${this.$t('tutorial[3].head')}, when you tap "${this.$t('commentTabTitle')}" tab at the lower left of the content you want to comment, a rectangular frame with "${this.$t('commentTabTitle')}" is displayed at the bottom of the screen.<br>
           Enter a comment in the box and then tap "${this.$t('senderTitle')}" button.<br>
           You can attach an image to a comment by tapping "clip".`
        },
        {
          head: `Put on "${this.$t('likesCountStr')}"`,
          body: `If you want to "Like" ${this.$t('tutorial[3].head')}, tap the gray ☆ mark below the content of the ${this.$t('sidebar.rtfbs.list')}.<br>
          Alternatively, you can tap the corresponding ${this.$t('tutorial[3].head')} to display the detail screen, and tap the gray ☆ mark below the ${this.$t('tutorial[3].head')} contents to add a “Like". If ☆ becomes orange, it means "Like".<br>
          You can check the list of users who added "Like" from "Like" tab of ${this.$t('rtfbDetailType')}.<br><br>
          If you want to "Like" comments on ${this.$t('tutorial[1].head')}, ${this.$t('tutorial[2].head')}, ${this.$t('tutorial[3].head')}, tap the gray ☆ mark below the comment you want to "Like".
          If ☆ becomes orange, it means "like".<br>
          You can check the list of users who added "Like" by tapping the "Like" number.`
        },
        {
          head: 'View notification',
          body: `If there is a red number next to the "${this.$t('sidebar.notice.title')}" at the bottom of the screen, you will see an unread notification.<br><br>
          To see the notification details, tap "${this.$t('sidebar.notice.title')}" to display a list. If you want to see detailed information such as ${this.$t('tutorial[1].head')}, ${this.$t('tutorial[2].head')}, ${this.$t('tutorial[3].head')}, etc. targeted for notification, select from the list and tap to go to the corresponding page.`
        },
        {
          head: 'Allow other users to receive notifications',
          body: `Tap "${this.$t('sidebar.notice.title')}" at the bottom of the screen, select "gear" at the top left, and tap the user or group you want to set.<br><br>
          As the message "${this.$t('receivePopupStr')}" will be displayed, tap "${this.$t('modalOkStr')}" to receive notification.<br>
          You can receive the following notifications for the configured user actions;<br>
          <ul class="list-adjusted">
            <li>・Create / update / delete ${this.$t('tutorial[1].head')}</li>
            <li>・Create / update / delete ${this.$t('tutorial[2].head')}</li>
            <li>・Create / update / delete ${this.$t('tutorial[3].head')}</li>
          </ul>`
        },
        {
          head: 'Confirm receipt of 1on1 request',
          body: `Tap "${this.$t('sidebar.notice.title')}" at the bottom of the screen and tap the icon "mail" in the upper right to display request reception history. Select the message you want to see, and check the details (source and comments).`
        },
        {
          head: `${this.$t('profileEditTitleStr')}`,
          body: `Tap "${this.$t('viewName.profile')}" submenu from "${this.$t('sidebar.other.title')}" at the bottom of the screen.<br>
          Tap the icon "pen" in the upper right, and tap the item you want to edit. (※ Email address is cannot be changed. )<br>
          When input is complete, select the “✓” in the upper right to finish.`
        },
        {
          head: 'Change Conditions',
          body: `Tap "${this.$t('viewName.profile')}" submenu from "${this.$t('sidebar.other.title')}" at the bottom of the screen.
          You can edit it from the icon "pen" in the upper right, select the condition (mark of the weather) and tap  "✓" to change it.<br>
          In addition, you can also change by selecting from the list of conditions by directly tapping the weather mark displayed in the header of the ${this.$t('sidebar.okr.list')} from the menu OKR at the bottom of the screen.`
        },
        {
          head: 'Log out',
          body: `Select the menu "${this.$t('tutorial[1].head')}" at the bottom of the screen and tap the icon "三" on the upper left, "Logout" will be displayed in the list menu, so tap it to log out and move to the login screen.`
        }
      ]
    }
  }
}
</script>
<style scoped>
  .web-hidden{
    display: none;
  }
  .p-1{
   padding: 0.5rem !important;
   transition: 0.2s all;
  }
  .card-header .btn{
    margin-top: 0;
  }
  .btn-info{
    background-color: #ffffff;
    border-color: #fcfcfc;
    padding: 0.8rem 1rem;
  }
  .btn-info:hover,.btn-info:focus, .btn-info.focus {
    color: #fff;
    background-color: #39b2d5;
    box-shadow: none;
  }
  .mb-1, .my-1{
    margin-bottom: 0.5rem !important;
  }
  .card-body, .card-block{
    padding: 1.5rem 1.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/_webview/WebViewHelpsEN.vue